export default "__VITE_ASSET__D8uE5Tm___"